// 30天有效期
export const COOKIE_EXPIRED_TIME = 30 * 24 * 3600;

// 登录库版本，编译时写入
export const LOGIN_VERSION = '2.0.15';

export const VIDEO_COOKIE = [
  'vuserid',
  'vusession',
  'main_login',
  'video_platform',
];

export const GUID_COOKIE = [
  'video_guid',
];

export const WXLOGIN_COOKIE = [
  'appid',
  'openid',
  'access_token',
  'refresh_token',
];

export const PTLOGIN_COOKIE = [
  'encuin',
  'luin',
  'lskey',
  'skey',
];

export const QQLOGIN_COOKIE = [
  'vqq_appid',
  'vqq_openid',
  'vqq_access_token',
  'vqq_vuserid',
  'vqq_vusession',
];

export const USERINFO_COOKIE = [
  'wx_nick',
  'wx_head',
  'qq_nick',
  'qq_head',
  'phone_nick',
  'phone_head',
];

// 汇总的视频票据
export const VIDEO_COOKIES = VIDEO_COOKIE.concat(WXLOGIN_COOKIE, QQLOGIN_COOKIE);
export const ALL_COOKIES = VIDEO_COOKIES.concat(USERINFO_COOKIE);

// TV 登录态的 appid
export const TV_APPIDS = ['wx16c9bb0f25d540ae', 'wx7b9044085d71f4f5', 'wx97b828e706a2b420', '101161688', '101180898', '101226103', '101249687', '101254487', '101414262', '101439899'];

// 登录账号类型
export const LOGIN_TYPE = {
  qq: 'qq',
  wx: 'wx',
  phone: 'phone',
  tvPhone: 'ph',
};

// 所有登录账号类型
export const ALL_LOGIN_TYPES = [LOGIN_TYPE.wx, LOGIN_TYPE.qq, LOGIN_TYPE.phone];

// 家庭账号角色
export const FAMILY_ROLE = {
  default: 0, // 普通账号
  parent: 1, // 父账号
  child: 2, // 子身份
};
